import {
  UpdateDiscountCodeInput,
  UpdateDiscountCodeOutput,
} from "@redotech/redo-model/order-editing/schemas/update-discount-code";

export const updateDiscountCodeSelfServe = {
  name: "updateDiscountCodeSelfServe" as const,
  input: UpdateDiscountCodeInput,
  output: UpdateDiscountCodeOutput,
};
